module.exports = __webpack_public_path__ + "assets/img/selectPatient-banner.bf621143.png";